import React, { useEffect, useState } from 'react';

// material
import { TextField, Tooltip } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import ClearIcon from '@mui/icons-material/Clear';
// components
import './index.css';
import { useNavigate } from 'react-router';
import { setIsOpenSearchBar } from '../../redux/mainReducer';
import { useSearchParams } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';

//

// ----------------------------------------------------------------------

function SearchBar({
  userData,
  language,
  margin = true,
  display = {
    xs: 'none',
    sm: userData?.id ? 'none' : 'block',
    md: userData?.id ? 'none' : 'block',
    lg: 'block',
    xl: 'block'
  }
}) {
  // eslint-disable-next-line
  const [search, setSearch] = useSearchParams();
  const [value, setValue] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    window.location.href.includes('search') && dispatch(setIsOpenSearchBar(true));
    window.location.href.includes('search') &&
      setValue(
        search.get('question') !== null && search.get('question').length !== 0
          ? search.get('question')
          : ''
      );
    // eslint-disable-next-line
  }, []);
  const navigate = useNavigate();

  return (
    <TextField
      variant="outlined"
      sx={{
        display: display,
        marginLeft: margin ? '30px' : '0px',
        marginRight: '0px',
        input: {
          fontFamily: 'FixelText-Regular',
          fontSize: '16px',
          lineHeight: '19px',
          letterSpacing: '0em',
          textAlign: 'left',
          color: '#7C7C7C !important',

          '&::placeholder': {
            fontFamily: 'FixelText-Regular',
            fontSize: '16px',
            lineHeight: '19px',
            letterSpacing: '0em',
            textAlign: 'left',
            color: '#7C7C7C !important'
            // <----- Add this.
            // opacity: 1,
          }
        }
      }}
      placeholder="Введіть свій пошуковий запит"
      fullWidth
      value={value}
      onChange={(e) => (e.target?.value !== null ? setValue(e.target.value) : setValue(''))}
      InputProps={{
        endAdornment: (
          <>
            {value.length !== 0 && (
              <ClearIcon
                sx={{
                  fontSize: '24px',
                  cursor: 'pointer',
                  mr: 2,
                  backgroundColor: 'white',
                  borderRadius: '50px',
                  padding: '5px',
                  ':hover': {
                    color: '#60A5DF'
                  }
                }}
                onClick={() => {
                  setValue('');
                  navigate(window.location.pathname);
                }}
              />
            )}
            <button
              style={{
                flexDirection: 'column',
                alignItems: 'center',
                border: 'none',
                backgroundColor: 'white',
                borderRadius: '50px',
                padding: '10px',
                cursor: 'pointer',
                height: '44px'
              }}
              onClick={() =>
                !window.location.href.includes('search')
                  ? navigate(
                      `/${language}/search/services?question=${value}&ftsb=creationTimeForService&sd=DESC`
                    )
                  : navigate(
                      `${window.location.pathname}?question=${value}${
                        search.get('ftsb') ? `&ftsb=${search.get('ftsb')}` : ''
                      }${search.get('sd') ? `&sd=${search.get('sd')}` : ''}`
                    )
              }
            >
              <Tooltip title="Пошук">
                <SearchIcon style={{ color: '#60A5DF' }} />
              </Tooltip>

              {/* <Typography
              variant="body2"
              component="span"

              sx={{ '&:hover': { color: '#60A5DF' } }}
            ></Typography> */}
            </button>
          </>
        )
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          !window.location.href.includes('search')
            ? navigate(
                `/${language}/search/services?question=${value}&ftsb=creationTimeForService&sd=DESC`
              )
            : navigate(
                `${window.location.pathname}?question=${value}${
                  search.get('ftsb') ? `&ftsb=${search.get('ftsb')}` : ''
                }${search.get('sd') ? `&sd=${search.get('sd')}` : ''}`
              );
        }
      }}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    isOpenSearchBar: state.global.isOpenSearchBar,
    userData: state.global.userData
  };
};
export default connect(mapStateToProps)(SearchBar);
